// extracted by mini-css-extract-plugin
export default {"soapUserView":"SoapUserView_soapUserView__gfAeP"};